import { Slot } from "@suse-o11y/slot";
import React from "react";

const LazyTrigger = React.lazy(async () => {
	// biome-ignore lint/style/noRestrictedImports: component usage
	const { Trigger } = await import("@radix-ui/react-dropdown-menu");

	return { default: Trigger };
});

export type DropdownMenuTriggerProps = React.ComponentProps<typeof LazyTrigger>;

export const DropdownMenuTrigger = React.forwardRef<React.ComponentRef<typeof LazyTrigger>, DropdownMenuTriggerProps>(
	({ asChild = true, ...props }, ref) => {
		const Root = asChild ? Slot : "button";

		return (
			<React.Suspense fallback={<Root ref={ref} {...props} />}>
				<LazyTrigger asChild={asChild} ref={ref} {...props} />
			</React.Suspense>
		);
	},
);

if (import.meta.env.DEV) {
	DropdownMenuTrigger.displayName = "DropdownMenuTrigger";
}
